import { NETWORK_DASHBOARD_STORE_AGE_FILTERS } from '@gozoki/api-types'
import { z } from 'zod'

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)

/**
 * Filtres de l'écran Inventaires, portés par l'URL (kanban #822). Sans `date` : aujourd'hui
 * (journée Europe/Paris, résolue côté client ET côté serveur) ; sans boutique : toutes les
 * boutiques ouvertes. L'ancienneté réutilise l'accordéon de `DashboardFilters` comme le RH.
 */
export const inventoriesSearchSchema = z.object({
  date: isoDate.optional(),
  storeIds: z.array(z.number()).optional(),
  storeAgeFilter: z.enum(NETWORK_DASHBOARD_STORE_AGE_FILTERS).optional().default('default'),
  ageStoreIds: z.array(z.number()).optional(),
  // Mode validation en masse (spec v2 §4.2) : le mode et ses seuils vivent dans l'URL comme les
  // autres filtres. Sans `bulkThresholdPct` : 10 % (arbitrage du 22/09) ; sans
  // `bulkThresholdPieces` : pas de plafond en pièces.
  bulk: z.boolean().optional(),
  bulkThresholdPct: z.number().min(0).max(100).optional(),
  bulkThresholdPieces: z.number().min(0).optional(),
})

export type InventoriesSearch = z.infer<typeof inventoriesSearchSchema>
